/*
 * Application Insights JavaScript SDK - React Plugin, 3.4.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import { createContext, useContext } from "react";
var AppInsightsContext = createContext(undefined);
var useAppInsightsContext = function useAppInsightsContext() {
  return useContext(AppInsightsContext);
};
export { AppInsightsContext, useAppInsightsContext };